/**
 * Locale Context
 *
 * @author    Frontend Design Systems <FrontendDesignSystems@wayfair.com>
 * @copyright 2019 Wayfair LLC - All rights reserved
 */

import React, {createContext} from 'react';
import PropTypes from 'prop-types';

export const imageContext = createContext({
  cdnUrl: null,
  imageKey: null,
});

const sharedErrorMessage =
  'You must provide both an imageKey and a cdnUrl prop to the ImageProvider so Image components can determine the src of the requested image.';

export function ImageProvider({children, imageKey, cdnUrl}) {
  if (typeof imageKey === 'undefined') {
    if (typeof cdnUrl === 'undefined') {
      throw new Error(`Error: No imageKey and cdnUrl props provided to the ImageProvider component.

${sharedErrorMessage}`);
    }
    throw new Error(
      `Error: No imageKey prop provided to the ImageProvider component.

${sharedErrorMessage}`
    );
  } else if (typeof cdnUrl === 'undefined') {
    throw new Error(`Error: No cdnUrl prop provided to the ImageProvider component.

${sharedErrorMessage}`);
  }
  return (
    <imageContext.Provider value={{imageKey, cdnUrl}}>
      {children}
    </imageContext.Provider>
  );
}

ImageProvider.propTypes = {
  // The content within the provider, this should be your application or any feature which needs to render an Image
  children: PropTypes.node.isRequired,
  // The Image Key, this is used by the `@wayfair/image-url-utils` library to get the image url
  imageKey: PropTypes.string.isRequired,
  // The CDN Url, this is used by the `@wayfair/image-url-utils` library to get the image url
  cdnUrl: PropTypes.string.isRequired,
};
